import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getSubmitterMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetSubmitterMasterRequestSchema,
  type GetSubmitterMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 計画提出者マスタ full entity 取得 hook。
 * members を含む全フィールドを返す。Edit modal の form initial value に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetSubmitterMaster(
  id: string | undefined,
): UseQueryResult<GetSubmitterMasterResponse, ConnectError> {
  return useQuery(
    getSubmitterMaster,
    create(GetSubmitterMasterRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
